import { EmptySearch } from '@/assets/icons/search';
import { Flex, Text } from '@chakra-ui/react';

export const EmptySearchResults = () => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      flexDir="column"
      height="300px"
      gap="5px"
    >
      <EmptySearch />
      <Text fontSize="14px">No search results are found</Text>
    </Flex>
  );
};
